export enum ViralWidgetDiscountValueType {
  Percentage = "percentage",
  Fixed = "fixed",
}
